/**
 * Case-to-Singles Add-to-Cart Override
 * Compatible with Flux Theme (ManaThemes) / Shopify Dawn
 *
 * When a customer selects "Case of 6", "Case of 8", or "Case of 12" and clicks Add to Cart,
 * this script intercepts and adds the equivalent number of single-unit variants
 * instead. This enables mix-and-match volume discounts across all dry pasta
 * products, where Shopify automatic discounts apply based on total bag count.
 *
 * INSTALLATION:
 *   1. In Shopify Admin: Online Store > Themes > Edit Code
 *   2. Under Assets, click "Add a new asset" and upload this file
 *   3. In layout/theme.liquid, add before </body>:
 *      <script src="{{ 'case-to-singles.js' | asset_url }}" defer></script>
 */
(function () {
    'use strict';
  
    // Case option prefixes mapped to their quantity multiplier
    var CASE_MULTIPLIERS = {
      'Case of 6': 6,
      'Case of 8': 8,
      'Case of 12': 12,
    };
  
    // Cache product JSON lookups so we only fetch once per product
    var productCache = {};
  
    /**
     * Get the product handle from variant-radios data attribute or page URL.
     */
    function getProductHandle(form) {
      // Try variant-radios data-url first (works on collection pages / quick-add)
      var productInfo = form.closest('product-info');
      if (productInfo) {
        var variantRadios = productInfo.querySelector('variant-radios');
        if (variantRadios) {
          var url = variantRadios.getAttribute('data-url');
          if (url) {
            var match = url.match(/\/products\/([^/?#]+)/);
            if (match) return match[1];
          }
        }
      }
  
      // Fall back to the sealsubs data attribute on the form
      var sealsubs = form.querySelector('[data-handle]');
      if (sealsubs) {
        var handle = sealsubs.getAttribute('data-handle');
        if (handle) return handle;
      }
  
      // Fall back to the page URL
      var pageMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
      if (pageMatch) return pageMatch[1];
  
      return null;
    }
  
    /**
     * Fetch and cache the product JSON to find variant IDs.
     */
    async function getProductData(handle) {
      if (productCache[handle]) return productCache[handle];
  
      var response = await fetch(
        window.Shopify.routes.root + 'products/' + handle + '.json'
      );
      if (!response.ok) throw new Error('Failed to fetch product: ' + handle);
  
      var data = await response.json();
      productCache[handle] = data.product;
      return data.product;
    }
  
    /**
     * Find the "Single" or "1 Pack" variant for a given product.
     */
    function findSingleVariant(product) {
      return product.variants.find(function (v) {
        return v.option1 === 'Single' || v.title === 'Single' ||
               v.option1 === '1 Pack' || v.title === '1 Pack';
      });
    }
  
    /**
     * Check if the selected option is a case variant and return the multiplier.
     * Returns 8, 12, or null.
     */
    function getCaseMultiplier(optionValue) {
      if (!optionValue) return null;
      for (var prefix in CASE_MULTIPLIERS) {
        if (optionValue.indexOf(prefix) === 0) return CASE_MULTIPLIERS[prefix];
      }
      return null;
    }
  
    /**
     * Get the currently selected Case Size radio value.
     * Scoped to the form's parent product-info to work on collection pages.
     */
    function getSelectedCaseOption(form) {
      // Try radios associated with this form via the form attribute
      var formId = form.getAttribute('id');
      if (formId) {
        var radios = document.querySelectorAll(
          'input[type="radio"][name*="Case Size"][form="' + formId + '"]'
        );
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked) return radios[i].value;
        }
      }
  
      // Try radios inside the closest product-info container
      var productInfo = form.closest('product-info');
      if (productInfo) {
        var radiosInside = productInfo.querySelectorAll(
          'input[type="radio"][name*="Case Size"]'
        );
        for (var j = 0; j < radiosInside.length; j++) {
          if (radiosInside[j].checked) return radiosInside[j].value;
        }
      }
  
      return null;
    }
  
    /**
     * Get the quantity from the quantity input field.
     */
    function getQuantity(form) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) return parseInt(qtyInput.value, 10) || 1;
  
      var productInfo = form.closest('product-info');
      if (productInfo) {
        qtyInput = productInfo.querySelector('input[name="quantity"]');
        if (qtyInput) return parseInt(qtyInput.value, 10) || 1;
      }
  
      return 1;
    }
  
    /**
     * Get the selling plan value (for Seal Subscriptions).
     */
    function getSellingPlan(form) {
      var input = form.querySelector('input[name="selling_plan"]');
      return input && input.value ? input.value : undefined;
    }
  
    /**
     * Set submit button loading state.
     */
    function setButtonLoading(button, loading) {
      if (!button) return;
      if (loading) {
        button.setAttribute('disabled', 'disabled');
        button.classList.add('loading');
        var spinner = button.querySelector('.loading-overlay-spinner');
        if (spinner) spinner.classList.remove('hidden');
        var text = button.querySelector(
          'span:not(.loading-overlay-spinner):not(.visually-hidden)'
        );
        if (text) text.style.visibility = 'hidden';
      } else {
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        var spinnerOff = button.querySelector('.loading-overlay-spinner');
        if (spinnerOff) spinnerOff.classList.add('hidden');
        var textOn = button.querySelector(
          'span:not(.loading-overlay-spinner):not(.visually-hidden)'
        );
        if (textOn) textOn.style.visibility = 'visible';
      }
    }
  
    /**
     * Open the drawer by adding the theme's classes (no open() call).
     * Matches cart-drawer.js open(): animate + active, body class, overflow.
     * Avoids trapFocus which was getting null when is-empty stayed set.
     */
    function openDrawerWithoutTrapFocus(drawer) {
      drawer.classList.add('animate', 'active');
      document.body.classList.add('cart-drawer-quick-view');
      if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
        document.body.style.overflow = 'hidden';
        document.body.style.padding = '0 4px 0 0';
      }
    }

    /**
     * Refresh the cart drawer after adding items.
     * Fetches updated drawer HTML so the new item shows, replaces content,
     * then opens the drawer by adding the theme's "active" class (never calls
     * drawer.open() or clicks the toggle, so trapFocus never runs and we avoid
     * getFocusableElements(null)).
     */
    function refreshCart() {
      // Update cart count bubbles
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          document
            .querySelectorAll(
              '.cart-count-bubble span, [data-cart-count], .cart-count'
            )
            .forEach(function (el) {
              el.textContent = cart.item_count;
            });
        });

      // Fetch cart drawer from cart page (same as theme's onCartUpdate) so we
      // get full cart context and line items (image, title, price). Using
      // product URL ?sections= can return section without full cart items.
      var cartSectionUrl =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url
          ? window.Shopify.routes.cart_url
          : window.Shopify.routes.root + 'cart') +
        '?section_id=cart-drawer';
      fetch(cartSectionUrl)
        .then(function (res) {
          return res.text();
        })
        .then(function (responseText) {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer) {
            window.location.href = '/cart';
            return;
          }

          var html = new DOMParser().parseFromString(responseText, 'text/html');
          var innerDrawer = html.querySelector('#CartDrawer');
          if (!innerDrawer) {
            var cartDrawerEl = html.querySelector('cart-drawer');
            innerDrawer = cartDrawerEl ? cartDrawerEl.querySelector('#CartDrawer') : null;
          }
          var target = drawer.querySelector('#CartDrawer');

          if (innerDrawer && target) {
            target.innerHTML = innerDrawer.innerHTML;
            // Theme's trapFocus uses .drawer-inner-empty when is-empty; after
            // we put non-empty content in, that element is gone → null. Remove
            // is-empty so if open() runs it uses getElementById('CartDrawer').
            drawer.classList.remove('is-empty');
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }

          // Open by adding theme classes only — do not call drawer.open() or
          // click the toggle, so trapFocus never runs (avoids null container).
          setTimeout(function () {
            openDrawerWithoutTrapFocus(drawer);
          }, 50);
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    }
  
    /**
     * Main intercept handler for form submissions and button clicks.
     */
    async function handleIntercept(event) {
      var form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;
  
      var selectedOption = getSelectedCaseOption(form);
      var multiplier = getCaseMultiplier(selectedOption);
  
      // If "Single" is selected, let the normal theme flow handle it
      if (!multiplier) return;
  
      // It's a case variant — intercept
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
  
      var submitButton = form.querySelector('[type="submit"]');
      setButtonLoading(submitButton, true);
  
      try {
        var handle = getProductHandle(form);
        if (!handle) throw new Error('Could not determine product handle');
  
        var product = await getProductData(handle);
        var singleVariant = findSingleVariant(product);
        if (!singleVariant) {
          throw new Error('No "Single" or "1 Pack" variant found for this product');
        }
  
        var quantity = getQuantity(form);
        var totalQty = quantity * multiplier;
        var sellingPlan = getSellingPlan(form);
  
        var item = {
          id: singleVariant.id,
          quantity: totalQty,
        };
        if (sellingPlan) {
          item.selling_plan = sellingPlan;
        }
  
        var response = await fetch(
          window.Shopify.routes.root + 'cart/add.js',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] }),
          }
        );
  
        if (!response.ok) {
          var errorData = await response.json();
          throw new Error(errorData.description || 'Failed to add to cart');
        }
  
        refreshCart();
      } catch (error) {
        console.error('[Case-to-Singles]', error);
  
        // Show error in the form's error area if available
        var errorWrapper = form.querySelector(
          '.product-form__error-message-wrapper'
        );
        var errorMessage = form.querySelector('.product-form__error-message');
        if (errorWrapper && errorMessage) {
          errorMessage.textContent =
            error.message || 'Could not add to cart. Please try again.';
          errorWrapper.removeAttribute('hidden');
          setTimeout(function () {
            errorWrapper.setAttribute('hidden', '');
          }, 5000);
        } else {
          alert('Could not add to cart: ' + (error.message || 'Unknown error'));
        }
      } finally {
        setButtonLoading(submitButton, false);
      }
    }
  
    /**
     * Initialize listeners in capture phase to intercept before theme scripts.
     */
    function init() {
      // Intercept form submit events
      document.addEventListener('submit', handleIntercept, true);
  
      // Also intercept button clicks (some themes bypass form submit)
      document.addEventListener(
        'click',
        function (e) {
          var btn = e.target.closest(
            'button[type="submit"], input[type="submit"]'
          );
          if (!btn) return;
  
          var form = btn.closest('form[action*="/cart/add"]');
          if (!form) return;
  
          var selectedOption = getSelectedCaseOption(form);
          if (getCaseMultiplier(selectedOption)) {
            handleIntercept(e);
          }
        },
        true
      );
  
      console.log(
        '[Case-to-Singles] Initialized — case variants will add singles to cart.'
      );
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();